import { Role } from "@/interfaces/Role";
import { RouteRecordRaw } from "vue-router";
import AppLayout from "@/layouts/AppLayout.vue";

export const clientRoutes: RouteRecordRaw[] = [
  {
    path: "/",
    component: AppLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: "/dashboard/overview",
        name: "ClientDashboardOverview",
        component: () => import("@/views/Dashboards/Dashboards.vue"),
        meta: {
          requiresAuth: true,
          role: Role.Client,
          icon: "pi pi-chart-bar",
          label: "navigation.overview",
          title: "titles.dashboardOverview",
          group: "Dashboard",
          order: 1,
        },
      },
      {
        path: "/dashboard/sales-overview",
        name: "ClientSalesOverview",
        component: () => import("@/views/Dashboards/SalesOverview.vue"),
        meta: {
          requiresAuth: true,
          role: Role.Client,
          icon: "pi pi-chart-line",
          label: "navigation.salesOverview",
          title: "titles.salesOverview",
          group: "Dashboard",
          order: 2,
        },
      },
      {
        path: "/dashboard/profit-loss",
        name: "ClientProfitLoss",
        component: () => import("@/views/Dashboards/ProfitLoss.vue"),
        meta: {
          requiresAuth: true,
          role: Role.Client,
          icon: "pi pi-dollar",
          label: "navigation.profitLoss",
          title: "titles.profitLoss",
          group: "Dashboard",
          order: 3,
        },
      },
      {
        path: "/dashboard/product-overview",
        name: "ClientProductOverview",
        component: () => import("@/views/Dashboards/ProductOverview.vue"),
        meta: {
          requiresAuth: true,
          role: Role.Client,
          icon: "pi pi-shopping-bag",
          label: "navigation.productOverview",
          title: "titles.productOverview",
          group: "Dashboard",
          order: 4,
        },
      },
      {
        path: "/dashboard/product-summary",
        name: "ClientProductSummary",
        component: () => import("@/views/Dashboards/ProductSummary.vue"),
        meta: {
          requiresAuth: true,
          role: Role.Client,
          icon: "pi pi-list",
          label: "navigation.productSummary",
          title: "titles.productSummary",
          group: "Dashboard",
          order: 5,
        },
      },
      {
        path: "/profile",
        name: "ClientProfile",
        component: () => import("@/views/Profile/Profile.vue"),
        meta: {
          requiresAuth: true,
          role: Role.Client,
          icon: "pi pi-cog",
          label: "navigation.settings",
          title: "titles.settings",
          group: "Profile",
          order: 6,
        },
      },
      {
        path: "/client/ad-cheker",
        name: "ClientAdCheker",
        component: () => import("@/views/Tools/AdCheker.vue"),
        meta: {
          requiresAuth: true,
          role: Role.Client,
          icon: "pi pi-cog",
          label: "navigation.adCheker",
          title: "titles.adCheker",
          group: "Tools",
          order: 7,
        },
      },
    ],
  },
];
